import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { VALID_FILTER } from '../../../../../../constants/service/common/utilConstants';
import GenerateCouponValidFailModalView from './GenerateCouponValidFailModalView';
import { appActions } from '../../../../../../store/modules/app';

const GenerateCouponValidFailModalContainer = (props) => {
  const { closeModal, validResult } = props;
  const dispatch = useDispatch();
  const [validFilterValue, setValidFilterValue] = useState(VALID_FILTER.ALL);
  const { userCouponList, ...restValidResult } = validResult;

  const handleExcelBulkGenerateCouponModal = () => {
    dispatch(
      appActions.appToggleModal({
        name: 'excelBulkGenerateCouponModal',
        value: true,
      }),
    );

    closeModal();
  };

  const isInValidItem = (item) =>
    item.userIsInvalid ||
    item.statusIsInvalid ||
    item.cellPhoneIsInvalid ||
    item.couponIsInvalid ||
    item.issuedIsInvalid;

  const filteredUserCouponList = userCouponList
    .map((item) => ({
      ...item,
      isInvalid: isInValidItem(item),
    }))
    .filter((item) => {
      if (validFilterValue === VALID_FILTER.INVALID) {
        return item.isInvalid;
      } else if (validFilterValue === VALID_FILTER.VALID) {
        return !item.isInvalid;
      } else {
        return true;
      }
    });

  return (
    <GenerateCouponValidFailModalView
      closeModal={closeModal}
      isValid={validFilterValue === VALID_FILTER.VALID}
      onOpenExcelBulkGenerateCouponModal={handleExcelBulkGenerateCouponModal}
      setValid={setValidFilterValue}
      validResult={{
        filteredUserCouponList,
        ...restValidResult,
      }}
    />
  );
};

export default GenerateCouponValidFailModalContainer;
